import Box from '@mui/material/Box'
import { m } from 'motion/react'
import type { ReactNode } from 'react'

import type { CurrentUser } from '@/api/auth'
import { fade } from '@/motion/presets'
import { SideRail } from './SideRail'
import { TopBar } from './TopBar'

export function AppShell({
  user,
  onLogout,
  leaving = false,
  children,
}: {
  user: CurrentUser
  onLogout: () => void
  /** Durante o logout o conteúdo esmaece antes de a rota trocar (M14). */
  leaving?: boolean
  children: ReactNode
}) {
  return (
    <m.div
      variants={fade}
      initial="hidden"
      // O `exit` do Motion só roda dentro de <AnimatePresence>, e a saída aqui
      // é uma troca de rota — daí animar por estado em vez de por desmontagem.
      animate={leaving ? 'hidden' : 'visible'}
      style={{ minHeight: '100dvh', display: 'flex' }}
    >
      <SideRail onLogout={onLogout} />

      <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar user={user} />

        <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, md: 3 } }}>
          {children}
        </Box>
      </Box>
    </m.div>
  )
}
